module.exports = __webpack_public_path__ + "static/img/laptop_macbookpro.580425d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/laptop_macbookpro.png
// module id = eA7Z
// module chunks = 0